<template>
  <div class="SelectItem">
    <div class="amount">
      <van-field
        v-model="amount"
        placeholder="请输入您的贷款金额"
        type="number"
        label=""
        maxlength="20"
      />
      <span class=" amountUntil unit">万元</span>
    </div>
    <div class="LoanTime">
      <p class="title">
        贷款期限
      </p>
      <div class="timeSlider">
        <van-slider
          :max="24"
          :min="1"
          :step="1"
          bar-height="5px"
          v-model="timeNumber"
          active-color="#FFCBC5"
        >
          <template #button>
            <div class="custom-button">
              <i class="customChild"></i>
            </div>
          </template>
        </van-slider>
      </div>
      <span class="itemUtil unit"> {{ timeNumber }}个月 </span>
    </div>
    <div class="LoanTime">
      <p class="title">
        贷款利率
      </p>
      <div class="timeSlider">
        <van-slider
          :max="20"
          :min="1"
          :step="1"
          bar-height="5px"
          v-model="rate"
          active-color="#FFCBC5"
        >
          <template #button>
            <div class="custom-button">
              <i class="customChild"></i>
            </div>
          </template>
        </van-slider>
      </div>
      <span class="itemUtil unit"> {{ rate }}% </span>
    </div>
    <div class="button" @click="doMath">算一算</div>
    <div class="line"></div>
  </div>
</template>
<script>
import { Toast } from 'vant';
import bus from '../utils/bus';

export default {
  name: 'SelectItem',
  data() {
    return {
      amount: '',
      timeNumber: 1,
      rate: 1,
    };
  },
  components: {
    // ValidVanField,
  },
  mounted() {
    bus.$on('switchClick', (tableData) => {
      if (!!this.amount && !!tableData && tableData.length > 0) {
        bus.$emit('getTableData', {
          amount: this.amount * 10000,
          timeNumber: this.timeNumber * 1,
          rate: this.rate / 12 / 100,
        });
      }
    });
  },
  methods: {
    doMath() {
      if (!this.amount) {
        Toast({
          message: '借款金额不能为空',
          position: 'top',
        });
        return;
      }
      if (this.amount <= 0) {
        Toast({
          message: '借款金额不能小于0',
          position: 'top',
        });
        return;
      }
      bus.$emit('getTableData', {
        amount: this.amount * 10000,
        timeNumber: this.timeNumber * 1,
        rate: this.rate / 12 / 100,
      });
    },
  },
};
</script>
<style scoped>
.SelectItem {
  width: 345px;
  box-sizing: border-box;
  padding: 0 16px;
  margin: 0 auto;
  background: #fff;
}
.unit {
  width: 45px;
  text-align: right;
  position: absolute;
  font-size: 14px;
  top: 12px;
  right: 0;
}
.amount {
  position: relative;
  border-bottom: 1px solid #dddee1;
}
.amountUntil {
  color: #000;
}
.title {
  text-align: left;
  color: #1c2438;
  font-size: 14px;
}
.timeSlider {
  position: relative;
}
.timeSlider {
  width: 260px;
}
.LoanTime {
  position: relative;
  padding-bottom: 24px;
  border-bottom: 1px solid #dddee1;
}
.custom-button {
  width: 15px;
  height: 15px;
  line-height: 15px;
  color: #fff;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  background-color: red;
  border-radius: 100%;
}
.customChild {
  display: block;
  width: 5px;
  height: 5px;
  background-color: #fff;
  border-radius: 100%;
  position: relative;
  top: 5px;
  left: 5px;
}
.itemUtil {
  color: #f55646;
  top: 24px;
}
.button {
  width: 318px;
  height: 46px;
  line-height: 46px;
  background: #f55646;
  border-radius: 8px;
  margin: 0 auto;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 20px;
}
.SelectItem >>> .van-cell:not(:last-child)::after {
  border-bottom: none !important;
}
.line {
  height: 1px;
}
</style>
